// ── HUD: scores, turn indicator, player info ──

import type { GameState, PlayerColor, PlayerSlot } from '../game/state';

export function renderHUD(
  container: HTMLElement,
  state: GameState,
  mySlot: PlayerSlot | null,
): void {
  let hud = container.querySelector('.hud') as HTMLElement | null;
  if (!hud) {
    hud = document.createElement('div');
    hud.className = 'hud';
    container.prepend(hud);
  }

  const p1 = state.meta.player1;
  const p2 = state.meta.player2;
  const isMyTurn =
    mySlot !== null && state.turn.activePlayer === mySlot;
  const activeColor =
    state.meta[state.turn.activePlayer]?.color ?? 'black';

  const spectating = mySlot === null;

  hud.innerHTML = `
    <div class="hud-left">
      <span class="hud-logo">LACUNA</span>
      ${spectating ? '<span class="hud-badge">Spectating</span>' : ''}
    </div>
    <div class="hud-center">
      <span class="hud-turn ${isMyTurn ? 'my-turn' : ''}">
        ${state.meta.status === 'finished'
          ? 'Game Over'
          : isMyTurn
            ? 'Your turn'
            : spectating
              ? `${state.meta[state.turn.activePlayer]?.name ?? 'Player'}'s turn`
              : 'Opponent\'s turn'}
      </span>
    </div>
    <div class="hud-right">
      <div class="hud-score">
        <span class="score-dot score-dot-black"></span>
        <span class="score-name">${p1?.name ?? '?'}</span>
        <span class="score-value" id="score-black">${state.scores.black}</span>
      </div>
      <div class="hud-score">
        <span class="score-dot score-dot-red"></span>
        <span class="score-name">${p2?.name ?? '?'}</span>
        <span class="score-value" id="score-red">${state.scores.red}</span>
      </div>
    </div>
  `;
}
